import styled from 'styled-components';

export const AgendaComponentWrapper = styled.div`
    position: relative;
    border-radius: 7px;
    background: #FAEAFC;
    margin-top: 3%;
    margin-left: 3%;
    width: 25%;
    `;

